"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrecision = void 0;
/**
 * 获取精度
 */
function getPrecision(value) {
    if (typeof value !== "number") {
        return 0;
    }
    var str = value.toString();
    if (/e-(.+)$/.test(str)) {
        return parseInt(RegExp.$1, 10);
    }
    if (str.indexOf(".") >= 0) {
        return str.length - str.indexOf(".") - 1;
    }
    return 0;
}
exports.getPrecision = getPrecision;
//# sourceMappingURL=get-precision.js.map